export const API_URL = 'https://api.adlerluiz.com/track-correios/';



// WEBPACK FOOTER //
// D:/DEV/angular/web-track-correios/config.ts